export default class ScrollHeroItem extends HTMLElement {
  private visuals: HTMLElement | null = null;
  private overlay: HTMLElement | null = null;
  private visualsHeight: number = 0;

  public index: number = 0;
  public isForeground: boolean = false;
  public top: number = 0;
  public itemHeight: number = 0;
  public vh: number = 0;

  private targetVisualsTransform: number = 0;
  private targetVisualsOpacity: number = 0;

  private targetOverlayOpacity: number = 0;

  private lastVisualsTransform: number = 0;
  private lastVisualsOpacity: number = 0;
  private lastOverlayOpacity: number = 0;

  private currentVisualsTransform: number = 0;
  private currentVisualsOpacity: number = 0;
  private currentOverlayOpacity: number = 0;

  connectedCallback(): void {
    this.index = parseInt(this.dataset.index ?? '0');
    this.isForeground = this.dataset.isForeground === 'true';

    this.visuals = this.querySelector('[data-scroll-hero-item-ref="visuals"]');
    this.overlay = this.querySelector('[data-scroll-hero-item-ref="overlay"]');
  }

  matchHeight(height: number): void {
    this.style.height = `${height}px`;

    const wrapper = this.firstElementChild as HTMLElement | null;

    if (wrapper) {
      wrapper.style.height = `${height}px`;
    }
  }

  resize(): void {
    this.vh = window.innerHeight;
    this.top = this.getBoundingClientRect().top + window.scrollY;
    this.itemHeight = this.offsetHeight;
    this.visualsHeight = this.visuals?.getBoundingClientRect().height ?? 0;
  }

  private getParallaxProgress(scrollY: number): number {
    const enterStart = this.top - this.vh;
    const enterEnd = this.top;
    const exitStart = this.top + this.itemHeight - this.vh;
    const exitEnd = this.top + this.itemHeight;

    if (scrollY < enterStart) {
      return -0.5;
    }

    if (scrollY > exitEnd) {
      return 0.5;
    }

    if (scrollY <= enterEnd) {
      const progress = (scrollY - enterStart) / this.vh;
      return progress / 2 - 0.5;
    }

    if (scrollY < exitStart) {
      return 0;
    }

    const progress = (scrollY - exitStart) / this.vh;
    return progress / 2;
  }

  update(): void {
    if (!this.visuals) {
      return;
    }

    const scrollY = window.scrollY;
    const parallaxProgress = this.getParallaxProgress(scrollY);

    this.targetVisualsTransform = this.visualsHeight * 0.25 * parallaxProgress;
    this.targetVisualsOpacity = 1 - Math.max(0, Math.abs(parallaxProgress * 2));
    this.targetOverlayOpacity = Math.max(0, Math.abs(parallaxProgress * 2));

    this.lastVisualsTransform = this.currentVisualsTransform;
    this.lastVisualsOpacity = this.currentVisualsOpacity;
    this.lastOverlayOpacity = this.currentOverlayOpacity;

    this.currentVisualsTransform = Number(this.targetVisualsTransform.toFixed(3));
    this.currentVisualsOpacity = Number(this.targetVisualsOpacity.toFixed(3));
    this.currentOverlayOpacity = Number(this.targetOverlayOpacity.toFixed(3));

    if (this.currentVisualsTransform !== this.lastVisualsTransform) {
      this.visuals.style.transform = `translate3d(0, ${this.currentVisualsTransform}px, 0)`;
      this.visuals.style.willChange = 'transform';
    } else {
      this.visuals.style.willChange = '';
    }

    if (this.isForeground) {
      if (this.currentVisualsOpacity !== this.lastVisualsOpacity) {
        this.visuals.style.opacity = String(this.currentVisualsOpacity);
        this.visuals.style.willChange = 'opacity';
      } else {
        this.visuals.style.willChange = '';
      }
    }

    if (this.overlay) {
      if (this.currentOverlayOpacity !== this.lastOverlayOpacity) {
        this.overlay.style.opacity = String(this.currentOverlayOpacity);
        this.overlay.style.willChange = 'opacity';
      } else {
        this.overlay.style.willChange = '';
      }
    }
  }
}

customElements.define('scroll-hero-item', ScrollHeroItem);
